module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('div', {
    staticClass: "score"
  }, [_vm._c('h3', [_vm._v("You got " + _vm._s(_vm.percentScore) + "% correct.")]), _vm._v(" "), _vm._c('div', {
    staticClass: "sub"
  }, [_vm._v("When do you want to re-study this micro-note?")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-11f7029e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter-studier/MicroNoteScore.vue
// module id = 623
// module chunks = 1